import { Scrollbars } from "react-custom-scrollbars";
import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Modulo = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  gap: 0.5em;
  border-radius: 0.625em 0.625em 0 0;
  padding: 1em 0.5em;
  align-items: center;

  .modulo-button {
    width: 100%;
  }
`;

export const ButtonMenu = styled.button`
  width: 2em;
  height: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.3125em;
  padding: 0.3em;
  background: ${Colors.Color14};
  border: 0;
  margin-bottom: 2em;

  img {
    width: 100%;
  }
`;

export const ModuloScroll = styled(Scrollbars)``;